__turbopack_export_value__({
  "hero": "Preloader-module__gDLKWq__hero",
  "heroContent": "Preloader-module__gDLKWq__heroContent",
  "heroHeader": "Preloader-module__gDLKWq__heroHeader",
  "heroSocial": "Preloader-module__gDLKWq__heroSocial",
  "introImg": "Preloader-module__gDLKWq__introImg",
  "line": "Preloader-module__gDLKWq__line",
  "nav": "Preloader-module__gDLKWq__nav",
  "navItem": "Preloader-module__gDLKWq__navItem",
  "navItems": "Preloader-module__gDLKWq__navItems",
  "navLogo": "Preloader-module__gDLKWq__navLogo",
  "preloader": "Preloader-module__gDLKWq__preloader",
  "preloaderOverlay": "Preloader-module__gDLKWq__preloaderOverlay",
});
